"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasInput = hasInput;
var isNaN_1 = __importDefault(require("lodash/fp/isNaN"));
var isEmpty_1 = __importDefault(require("lodash/fp/isEmpty"));
/**
* Determine whether user had input anything.
*
* @param input - User input.
*
* @example
* ```typescript
* hasInput('') // false
* hasInput('  ') // true
* hasInput(NaN) // false
* hasInput('input') // true
* hasInput(0) // true
* hasInput(null) // false
* hasInput(undefined) // false
* ```
* */
function hasInput(input) {
    return !((typeof input === 'string' && !input.length)
        || (0, isNaN_1.default)(input)
        || ((0, isEmpty_1.default)(input) && typeof input !== 'number' && !(input instanceof Date)));
}
